/**
 * Scroll-to-top button: shows after scroll threshold, smooth-scrolls to top on click.
 * Uses custom element for encapsulation. Namespaced under window to avoid globals.
 */
(function () {
  const SCROLL_THRESHOLD_PX = 400;

  class ScrollToTop extends HTMLElement {
    constructor() {
      super();
      this._boundOnScroll = this._onScroll.bind(this);
      this._boundOnClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this._button = this.querySelector('.scroll-to-top__button');
      if (!this._button) return;

      this._button.addEventListener('click', this._boundOnClick);
      window.addEventListener('scroll', this._boundOnScroll, { passive: true });
      this._onScroll();
    }

    disconnectedCallback() {
      if (this._button) this._button.removeEventListener('click', this._boundOnClick);
      window.removeEventListener('scroll', this._boundOnScroll);
    }

    _onScroll() {
      if (window.scrollY > SCROLL_THRESHOLD_PX) {
        this.removeAttribute('hidden');
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
        this.setAttribute('hidden', '');
      }
    }

    _onClick() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  if (!customElements.get('scroll-to-top')) {
    customElements.define('scroll-to-top', ScrollToTop);
  }
})();
